import data from './data/country-code.json';

export const getDialCode = (code) => {
    const item = data.find((item) => item.code === code); 
    return item && item.dial_code ? item.dial_code : null;
}